export default "__VITE_ASSET__BACi3Z5L__"